export const fontWeight = {
  Regular: 400,
  Medium: 500,
  Semibold: 600,
  Bold: 700,
} as const;
